// extracted by mini-css-extract-plugin
export default {"root":"bLktx","title":"G6WB_","icon":"KDNh3"};